import { render, staticRenderFns } from "./Stockcheck.vue?vue&type=template&id=76cf4b52&"
import script from "./Stockcheck.vue?vue&type=script&lang=js&"
export * from "./Stockcheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports